import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import CheckoutPage from "@/pages/CheckoutPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AccountPage from "@/pages/AccountPage";
import ContactPage from "@/pages/ContactPage";
import PolicyPage from "@/pages/PolicyPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminProductForm from "@/pages/admin/AdminProductForm";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminInventory from "@/pages/admin/AdminInventory";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminTypes from "@/pages/admin/AdminTypes";
import AdminBulkImages from "@/pages/admin/AdminBulkImages";
import AdminOffer from "@/pages/admin/AdminOffer";
import AdminSocial from "@/pages/admin/AdminSocial";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminWhatsAppLeads from "@/pages/admin/AdminWhatsAppLeads";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { CartDrawer } from "@/components/cart/CartDrawer";
import { OfferPopup } from "@/components/OfferPopup";

// Smooth momentum scrolling (Lenis) — premium, purposeful motion.
const SmoothScroll = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return children;
};

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <AuthProvider>
            <CartProvider>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/product/:slug" element={<ProductPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/privacy-policy" element={<PolicyPage docKey="privacy-policy" />} />
                <Route path="/terms" element={<PolicyPage docKey="terms" />} />
                <Route path="/shipping-policy" element={<PolicyPage docKey="shipping-policy" />} />
                <Route path="/returns-refunds" element={<PolicyPage docKey="returns-refunds" />} />
                <Route path="/cancellation-policy" element={<PolicyPage docKey="cancellation-policy" />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/products" element={<AdminProducts />} />
                <Route path="/admin/products/new" element={<AdminProductForm />} />
                <Route path="/admin/products/:slug" element={<AdminProductForm />} />
                <Route path="/admin/categories" element={<AdminCategories />} />
                <Route path="/admin/inventory" element={<AdminInventory />} />
                <Route path="/admin/orders" element={<AdminOrders />} />
                <Route path="/admin/types" element={<AdminTypes />} />
                <Route path="/admin/bulk-images" element={<AdminBulkImages />} />
                <Route path="/admin/offer" element={<AdminOffer />} />
                <Route path="/admin/social" element={<AdminSocial />} />
                <Route path="/admin/coupons" element={<AdminCoupons />} />
                <Route path="/admin/whatsapp-leads" element={<AdminWhatsAppLeads />} />
              </Routes>
              <CartDrawer />
              <OfferPopup />
            </CartProvider>
          </AuthProvider>
        </SmoothScroll>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#FFFDFA",
            border: "1px solid #E7E2D8",
            color: "#1C1917",
            borderRadius: "4px",
          },
        }}
      />
    </div>
    </HelmetProvider>
  );
}

export default App;
